// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint import/no-webpack-loader-syntax: off */
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/app.css'
import '@/assets/designer.css'
import '@/assets/vapp-tour.css'
import '@/assets/designer.common.css'
import '@/assets/util.scss'
import '@/assets/el-override.scss'
import 'chartist/dist/scss/chartist.scss'
import 'swiper/dist/css/swiper.css'
import 'v-infinite-scroll/dist/v-infinite-scroll.css'

import Vue from 'vue'
import VueGtm from 'vue-gtm'
import App from './App'
import ElementUI from 'element-ui'

// import locale from 'element-ui/lib/locale/lang/en'
import router from './router'
import VueResource from 'vue-resource'
import store from '@/store/index'
import VueCarousel from 'vue-carousel'
import VueValidator from 'simple-vue-validator'
import { sync } from 'vuex-router-sync'
import { getDefaultOrBrowserLanguage } from '@/modules/helper/index'
import VueTour from 'vue-tour'
import VueScroller from 'vue-scroller'
import InfiniteScroll from 'v-infinite-scroll'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import 'babel-polyfill'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
require('imports-loader?jQuery=jquery!justifiedGallery')
require('vue-tour/dist/vue-tour.css')
let { language } = getDefaultOrBrowserLanguage('de')
let locale = require('element-ui/lib/locale/lang/' + language).default
require('vue-tour/dist/vue-tour.css')
Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(VueResource)
Vue.use(VueCarousel)
Vue.use(VueValidator)
Vue.use(VueTour)
Vue.use(VueScroller)
Vue.use(InfiniteScroll)
Vue.use(ClipLoader)
if (process.env.NODE_ENV !== 'development') {
  Vue.use(VueGtm, {
    appName: 'designer.onair-appbuilder.com', // Mandatory
    appVersion: '2', // Mandatory
    trackingId: 'GTM-542Z9H5', // Mandatory
    debug: process.env.NODE_ENV !== 'production', // Whether or not display console logs debugs (optional)
    vueRouter: router // Pass the router instance to automatically sync with router (optional)
  })
}

sync(store, router)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  VueTour,
  template: '<App/>',
  components: {
    App,
    ClipLoader
  },
  store
})



// WEBPACK FOOTER //
// ./src/main.js